import { ofType } from 'redux-observable';
import { ajax } from 'rxjs/ajax';
import { map, switchMap, catchError } from 'rxjs/operators';
import {
  SEND_EMAIL_INVITATION,
  SEND_EMAIL_INVITATION_SUCCESS
} from '../../constants';

import { toast } from 'react-toastify';

let toastId = 'sendEmail';


const sendEmailInvitation = (action$, state$) =>
  action$.pipe(
    ofType(SEND_EMAIL_INVITATION),
    switchMap(action => {

      toastId = toast('Sending Email Invitation..', {
        id: toastId,
        autoClose: false,
        position: 'top-center',
        style: { textAlign: 'center' },
        closeButton: false, // Remove the closeButton
      });

      return ajax({
        url:  `${state$.value.auth.server}/campaigns/${action.campaignId}/share`,
        headers: {
          Authorization: state$.value.auth.token,
        },
        body: action.payload,
        crossDomain: true,
        method: 'POST',
      }).pipe(
        map(response => {

          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: "Email sent.",
            autoClose: 3000,
            hideProgressBar: true,
            progress: undefined,
            style: { backgroundColor: 'rgb(237, 247, 237)', color: 'rgb(30, 70, 32)', textAlign: 'center' },
            closeButton: null // The closeButton defined on ToastContainer will be used
          });

          return {
            type: SEND_EMAIL_INVITATION_SUCCESS,
            data: response.response
          };
        }),
        catchError(error => {
          console.log(error);
          toast.update(toastId, {
            id: toastId,
            type: toast.TYPE.INFO,
            render: error.response.message,
            autoClose: 6000,
            hideProgressBar: true,
            progress: undefined,
            style: { backgroundColor: 'rgb(253, 236, 234)', color: 'rgb(97, 26, 21)', textAlign: 'center' },
            closeButton: null // The closeButton defined on ToastContainer will be used
          });
        })
      );
    })
  );

export default sendEmailInvitation;
